import { render, staticRenderFns } from "./PayrollsList.vue?vue&type=template&id=73c54de6&scoped=true&"
import script from "./PayrollsList.vue?vue&type=script&lang=js&"
export * from "./PayrollsList.vue?vue&type=script&lang=js&"
import style0 from "./PayrollsList.vue?vue&type=style&index=0&id=73c54de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c54de6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c54de6')) {
      api.createRecord('73c54de6', component.options)
    } else {
      api.reload('73c54de6', component.options)
    }
    module.hot.accept("./PayrollsList.vue?vue&type=template&id=73c54de6&scoped=true&", function () {
      api.rerender('73c54de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/History/PayrollsList.vue"
export default component.exports